















import Vue from "vue";

import iwInputPrice from "@/encoding/components/buildingBlocks/InputPrice.vue";

export default Vue.extend({
    components: {
        iwInputPrice: iwInputPrice
    },
    data: function() {
        return {
            pathInStore: "property.specificities.shop.goodwillPrice",
        };
    },
    computed: {
        priceOfBusiness: function(): string {
            return this.$store.getters["FormModule/getValue"](this.pathInStore) ?? "";
        },
    },
    methods: {
        updateValue: function(priceOfBusiness: number): void {
            if (priceOfBusiness === 0) {
                this.$store.commit("FormModule/deleteValue", this.pathInStore);
            } else {
                this.$store.dispatch("FormModule/addValue", {"path": this.pathInStore, "value": priceOfBusiness});
            }
        }
    }
});
